import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import sports from "../../assets/images/sports_meet.jpg";

const API_URL = process.env.REACT_APP_API_URL || "https://api.npskudlu.com/api";
const EVENTS_ENDPOINT = `${API_URL}/v1/get-activity`;

const EventsAllOne = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEvents = async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("token");
      const resp = await axios.get(EVENTS_ENDPOINT, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      const payload = resp.data;
      let items = [];

      if (Array.isArray(payload?.data)) items = payload.data;
      else if (Array.isArray(payload?.events)) items = payload.events;
      else if (Array.isArray(payload)) items = payload;

      // normalize items and include activityDate specifically
      items = items.map((it) => {
        // pick image safely
        const img =
          (typeof it.image === "string" && it.image) ||
          (Array.isArray(it.image) &&
            (it.image[0]?.mediaLink || it.image[0]?.url || it.image[0])) ||
          it.mediaLink ||
          it.thumbnail ||
          null;

        return {
          id: it._id || it.id || it.eventId || null,
          title: it.title || it.name || it.name || "Untitled Event",
          // include both standardized date fields for compatibility
          activityDate:
            it.activityDate || it.date || it.eventDate || it.startDate || null,
          date:
            it.activityDate || it.date || it.eventDate || it.startDate || null,
          image: img,
          slug: it.slug || it.handle || null,
          raw: it,
        };
      });

      setEvents(items);
    } catch (err) {
      console.error("Failed to fetch events:", err);
      setError(err.response?.data || err.message || "Failed to load events");
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Returns day(2-digit), month(3-letter, uppercase) and full localized date string
  const formatDay = (dateStr) => {
    if (!dateStr) return { day: "??", month: "???", full: "" };
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime()))
      return { day: "??", month: "???", full: dateStr };

    // Day as two digits
    const day = String(d.getDate()).padStart(2, "0");
    // Month short (e.g., OCT)
    const month = d.toLocaleString(undefined, { month: "short" }).toUpperCase();
    // Full readable date/time using user's locale
    const full = d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    return { day, month, full };
  };

  return (
    <section className="course-list-view py-80 bg-white">
      <div className="container">
        {loading && <p>Loading events...</p>}

        {error && (
          <div className="mb-16 text-red-600">
            <p>
              Unable to load events:{" "}
              {typeof error === "string" ? error : JSON.stringify(error)}
            </p>
            <button className="btn btn-primary" onClick={fetchEvents}>
              Retry
            </button>
          </div>
        )}

        {!loading && !error && events.length === 0 && <p>No events found.</p>}

        <div className="row gy-4">
          {!loading &&
            !error &&
            events.map((ev) => {
              // Use the normalized activityDate (falls back to other date fields)
              const dt = formatDay(ev.activityDate || ev.date);
              const imgSrc = ev.image || sports;
              const to = `/activities/${ev.id || ""}`;

              return (
                <div
                  className="col-xl-4 col-sm-6"
                  key={ev.id || `${ev.title}-${Math.random()}`}
                >
                  <div className="scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30">
                    <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                      <Link to={to} className="w-100 h-100" tabIndex={0}>
                        <img
                          src={imgSrc}
                          alt={ev.title}
                          className="scale-hover-item__img rounded-12 cover-img transition-2"
                          onError={(e) => {
                            e.currentTarget.src = sports;
                          }}
                        />
                      </Link>

                      <div className="position-absolute inset-inline-end-0 inset-block-end-0 me-16 mb-16 py-12 px-24 rounded-8 bg-main-two-600 text-white fw-medium">
                        <h3 className="mb-0 text-white fw-medium">{dt.day}</h3>
                        {dt.month}
                      </div>
                    </div>

                    <div className="pt-32 pb-24 px-16 position-relative">
                      <h4 className="mb-28">
                        <Link to={to} className="link text-line-2" tabIndex={0}>
                          {ev.title}
                        </Link>
                      </h4>

                      <div className="flex-between gap-8 pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                        <Link
                          to={to}
                          className="flex-align gap-8 text-main-600 hover-text-decoration-underline transition-1 fw-semibold"
                          tabIndex={0}
                        >
                          View Details
                          <i className="ph ph-arrow-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default EventsAllOne;
